<div
  class="image blurred"
  #blurredImgEl></div>
<div
  class="image"
  #imgEl
  [ngClass]="'background-' + backgroundSize"></div>

<ng-content></ng-content>
